<template>
  <div style="background: #f9f9f9; height: calc(100vh - 44px)">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack">
        <img src="@/assets/img/appointment/back.svg" />
      </div>
      <div class="nav-title d-allcenter overflow">添加新伙伴</div>
      <div class="nav-right d-allcenter" style="font-size: 12px"></div>
    </div>
    <div class="content d-aligncnter d-column d-allcenter">
      <div class="search-box d-aligncnter">
        <input
          v-model="searchText"
          style="width: calc(100% - 80px); height: 40px; margin-left: 18px; border: none; outline: none"
        />
        <div class="d-allcenter" style="width: 52px; height: 52px" @click="searchData">
          <img src="@/assets/img/appointment/search.svg" class="search-img" />
        </div>
      </div>
      <div class="grey" style="padding: 0 16px">
        操作说明：输入手机号查找新伙伴。伙伴必须在其账号里录入人脸信息才能被邀请。
      </div>

      <div style="padding: 0 16px">
        <el-checkbox-group v-model="checkList" @change="friendsChange">
          <div class="info-box" v-for="(item, index) in friendList" :key="'friend_' + index">
            <el-checkbox :label="item.userId" class="d-aligncnter mycheck">
              <div class="d-between d-aligncnter" style="width: calc(100vw - 94px)">
                <div class="d-column">
                  <div>{{ item.name }}</div>
                  <div class="grey">{{ item.mobile }}</div>
                </div>
                <div
                  class="fs-xs"
                  style="color: #fff; background: #e14c46; padding: 2px 4px; border-radius: 90px"
                  v-if="!item.face"
                >
                  缺少人脸数据
                </div>
              </div>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <!-- <div class="d-allcenter" style="position: fixed; bottom: 32px; width: 100vw"> -->
    <div class="d-allcenter" v-if="friendList.length > 0">
      <button class="save-btn" style="width: 136px" @click="addSave">
        <div>添加</div>
      </button>
    </div>

    <div></div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { searchPartner, addPartner } from '@/api/api-venueOrder'

import wx from 'weixin-jsapi'
export default {
  data() {
    return {
      phone: '',
      userInfo: { headImg: '', name: '', mobile: '' },
      rightText: '编辑',
      radio: 0,
      checkList: [],
      friendList: [
        // { name: '张三', mobile: '152****8888', id: 1, face: true },
        // { name: '李四', mobile: '152****8888', id: 2, face: true },
        // { name: '王五', mobile: '152****8888', id: 3, face: true },
        // { name: '赵六', mobile: '152****8888', id: 4, face: false },
      ],
      searchText: '',
    }
  },
  mounted() {
    this.ifWeChat()
  },
  methods: {
    wechatPay() {
      wx.config({
        debug: true, //开发时true，发布到线上时false
        appId: 'wxb4c490a00a0736ee', //必填 公众号唯一标识
        timestamp: 1414587457, //必填 生成签名的时间戳
        nonceStr: '', //必填 生成签名的随机串
        signature: '', //必填 签名
        jsApiList: ['chooseWXPay', 'checkJsApi'], //必填 需要使用的js接口列表
      })

      wx.ready(() => {
        wx.chooseWXPay({
          timestamp: 1414587457, //必填 生成签名的时间戳
          nonceStr: '', //必填 生成签名的随机串
          package: '', //统一支付接口返回的prepay_id参数值,提交格式如：prepay_id=***）
          signType: 'MD5', //签名算法，默认SHA1 使用新版支付传入MD5
          paySign: '', //必填 签名
          success: function (payRes) {
            //支付成功后回调
            console.log(payRes)
          },
          cancel: function (payRes) {
            //支付取消后的回调函数
            console.log(payRes)
          },
          fail: function (payRes) {
            //支付失败后的回调函数
            console.log(payRes)
          },
        })
      })
    },
    //判断是否是微信移动端
    ifWeChat() {
      var isWeChatBrowser = /microMessenger/i.test(navigator.userAgent)
      let isMobile = /(iPhone|iPad|iPod|iOS|Android|webOS|BlackBerry|Opera Mini|IEMobile)/i.test(navigator.userAgent)
      if (isWeChatBrowser) {
        //微信浏览器
        if (isMobile) {
          //移动端
          console.log('移动端')
        } else {
          //pc端
          console.log('pc端')
        }
      } else {
        //非微信
        console.log('非微信')
      }
    },
    pageToBack() {
      this.$router.go(-1)
    },
    friendsChange(e) {
      console.log('e:', e)
      console.log(this.checkList)
    },
    searchData() {
      this.checkList = []
      console.log(this.searchText)
      searchPartner(this.searchText).then((res) => {
        if (res.data.statusCode == 1) {
          this.friendList = res.data.obj
          if (this.friendList.length == 0) {
            Message.error('请确认输入手机号正确')
          }
        } else {
          Message.error(res.data.message)
        }
      })
    },
    addSave() {
      const userId = localStorage.getItem('userId')
      addPartner(userId, this.checkList[0]).then((res) => {
        if (res.data.statusCode == 1) {
          Message.success('添加成功')
          this.checkList = []
          this.searchText = ''
          this.friendList = []
        } else {
          Message.error(res.data.message)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}
.content {
  padding: 0;
  background: #f9f9f9;
}
.each {
  background: #f9f9f9;
  box-shadow: 0px -1px 0px 0px #e8e8e8 inset;
  padding: 8px 16px;
  min-height: 32px;
  color: #181818;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4a3fc;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.save-btn {
  border-radius: 52px;
  //   background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  background: #339571;
  width: 343px;
  height: 42px;
  border: 1px solid #339571;
  color: #fff;
  font-size: 14px;
  margin-top: 16px;
  //   position: absolute;
  //   bottom: 152px;
}
.ml-16 {
  margin-left: 16px;
}
.order-info {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  //   padding: 16px;
  margin: 16px;
  width: calc(100% - 64px);
}
.info-box {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  width: calc(100% - 64px);
  padding: 8px 16px;
  margin: 16px;
}

.info-box ::v-deep .el-checkbox__inner::after {
  height: 10px;
  left: 7px;
  top: 3px;
}
.info-box ::v-deep .el-checkbox__inner {
  width: 20px;
  height: 20px;
}
.info-box ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #339571;
  border-color: #339571;
}
.info-box ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #339571;
}
.info-box ::v-deep .el-checkbox__inner:hover {
  border-color: #339571 !important;
}
.info-box ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #339571 !important;
}
.mycheck {
  margin: 6px 0;
}
.search-box {
  border-radius: 100px;
  border: 1px solid #007a4d;
  background: #fff;
  width: calc(100% - 32px);
  min-height: 52px;
  margin: 16px 0;
}
.search-img {
  width: 24px;
  height: 24px;
}
</style>
